module.exports = __webpack_public_path__ + "images/apple-touch-icon-72x72.8c159dbe3c803e96d62b0cba0ad86bf8.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-72x72.png
// module id = 995
// module chunks = 0